























































































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule, UserModule } from '../../store'
import { findItemForTree, getArrAccordWithConditionChildForTree, getAnyOneForListOnFlatteningForTree } from '../../utils/toolsForCommon'
import countTo from 'vue-count-to'
@Component({
  name: 'CanteenIndex',
  components: {
    'empty-container': () => import('../../components/empty.vue'),
    'count-to': countTo
  }
})
export default class CanteenIndex extends Vue {
  // 通知公告：
  public informList: any[] = [];
  public informListLoading: boolean = false;
  public informListCurrentPage: number = 1;
  public informListPageSize: number = 10;
  public informListTotal: number = 0;
  // 政策文件：
  public policyList: any[] = [];
  public policyListLoading: boolean = false;
  public policyListCurrentPage: number = 1;
  public policyListPageSize: number = 10;
  public policyListTotal: number = 0;
  // charts：
  public myChartForEchartsContainerForItemRightForSchool: any = null
  public myChartForEchartsContainerForItemRightForUser: any = null
  public optionForEchartsContainerForItemRightForSchool: any = {
    tooltip: {
      show: true,
      trigger: 'item'
    },
    series: [
      {
        name: '学校数量',
        type: 'pie',
        radius: ['50%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        labelLine: {
          show: false
        },
        color: ['#5F60D3', '#8FE5CD'],
        data: [
          {
            name: '当前组织学校数量',
            value: 0
          },
          {
            name: '总学校数量',
            value: 0
          }
        ]
      }
    ]
  }
  public optionForEchartsContainerForItemRightForUser: any = {
    tooltip: {
      show: true,
      trigger: 'item'
    },
    series: [
      {
        name: '用户数量',
        type: 'pie',
        radius: ['50%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        labelLine: {
          show: false
        },
        color: ['#FDD97E', '#F7A8A7'],
        data: [
          {
            name: '当前组织用户数量',
            value: 0
          },
          {
            name: '总用户数量',
            value: 0
          }
        ]
      }
    ]
  }
  // 当前节点的相关数量：
  // 学校：
  public schoolListForThisNode: any[] = []
  // 用户：
  public userListForThisNode: any[] = []
  // 所有节点的相关数量：
  // 学校：
  public schoolListForAllNode: any[] = []
  // 用户：
  public userListForAllNode: any[] = []
  // 所有节点的图谱相关：
  public myChartForEchartsContainerForAllNode: any = null
  public optionForEchartsContainerForAllNode: any = {
    title: {
      text: '您所在的组织总览'
    },
    backgroundColor: 'transparent',
    tooltip: {},
    selectedMode: 'false',
    bottom: 20,
    left: 0,
    right: 0,
    top: 0,
    animationDuration: 1500,
    animationEasingUpdate: 'quinticInOut',
    series: [
      {
        cursor: 'default',
        name: '组织图谱',
        type: 'graph',
        hoverAnimation: false,
        layout: 'force',
        force: {
          repulsion: 300, // 节点之间的斥力因子。
          edgeLength: 80,
          // layoutAnimation: false
          layoutAnimation: true
        },
        nodeScaleRatio: 0.6,
        // draggable: true,
        draggable: false,
        roam: true,
        symbol: 'circle',
        data: [],
        links: [],
        focusNodeAdjacency: true,
        scaleLimit: {
          // 所属组件的z分层，z值小的图形会被z值大的图形覆盖
          min: 0.5, // 最小的缩放值
          max: 9 // 最大的缩放值
        },
        edgeSymbol: ['circle', 'arrow'],
        edgeSymbolSize: [0, 0],
        label: {
          normal: {
            show: true,
            position: 'right',
            color: 'red',
            distance: 5,
            fontSize: 10
          }
        },
        lineStyle: {
          normal: {
            width: 1,
            // color: "red",
            curveness: 0,
            type: 'dashed',
            join: 'round',
            cap: 'butt'
          }
        }
      }
    ]
  };

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.getInformList()
    this.getPolicyList()
    setTimeout(() => {
      this.initCharts()
      this.updateCharts(this.myChartForEchartsContainerForItemRightForSchool, this.optionForEchartsContainerForItemRightForSchool)
      this.updateCharts(this.myChartForEchartsContainerForItemRightForUser, this.optionForEchartsContainerForItemRightForUser)
      this.updateCharts(this.myChartForEchartsContainerForAllNode, this.optionForEchartsContainerForAllNode)
      this.calcForCharts()
    }, 300)
    this.$on('hook:beforeDestroy', () => {
      const _that = this
      window.removeEventListener('resize', function () {
        _that.myChartForEchartsContainerForItemRightForSchool.resize()
        _that.myChartForEchartsContainerForItemRightForUser.resize()
        _that.myChartForEchartsContainerForAllNode.resize()
      })
    })
  }

  async getInformList () {
    try {
      const _that: any = this
      this.informListLoading = true
      const params = {
        pageNo: _that.informListCurrentPage,
        pageSize: _that.informListPageSize,
        type: 'INFORM_ANNOUNCEMENT',
        loginUserType: 0,
        module: 'CANTEEN_MODULE'
      }
      const { data: result } = await _that.$http.newAnnouncementUserAnnouncementPage(params)
      this.informListLoading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.informList = [...this.informList, ...((result.data && result.data.records) || [])]
      this.informListTotal = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  async getPolicyList () {
    try {
      const _that: any = this
      this.policyListLoading = true
      const params = {
        pageNo: _that.policyListCurrentPage,
        pageSize: _that.policyListPageSize,
        type: 'POLICY_FILE',
        loginUserType: 0,
        module: 'CANTEEN_MODULE'
      }
      const { data: result } = await _that.$http.newAnnouncementUserAnnouncementPage(params)
      this.policyListLoading = false
      if (result.code !== 200) return (this as any).$message.error(result.msg)
      this.policyList = [...this.policyList, ...((result.data && result.data.records) || [])]
      this.policyListTotal = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  informLoad () {
    const totalPages = Math.ceil(this.informListTotal / this.informListPageSize)
    if (this.informListCurrentPage >= totalPages) {
      if (this.informListPageSize !== 0 && totalPages > 1) {
        this.$message.warning('通知公告没有更多啦！')
      }
    } else {
      this.informListCurrentPage++
      this.getInformList()
    }
  }

  policyLoad () {
    const totalPages = Math.ceil(this.policyListTotal / this.policyListPageSize)
    if (this.policyListCurrentPage >= totalPages) {
      if (this.policyListPageSize !== 0 && totalPages > 1) {
        this.$message.warning('政策文件没有更多啦！')
      }
    } else {
      this.policyListCurrentPage++
      this.getInformList()
    }
  }

  operationOfGoDetail (item: any): void {
    this.$router.push({
      name: 'CanteenIndexConfigDetail',
      query: {
        id: item.id
      }
    })
  }

  initCharts () {
    const _that: any = this
    this.myChartForEchartsContainerForItemRightForSchool = (this as any).$echarts.init(document.getElementById('echartsContainerForItemRightForSchool'))
    this.myChartForEchartsContainerForItemRightForUser = (this as any).$echarts.init(document.getElementById('echartsContainerForItemRightForUser'))
    this.myChartForEchartsContainerForAllNode = (this as any).$echarts.init(document.getElementById('echartsContainerForAllNode'))
    window.addEventListener('resize', function () {
      _that.myChartForEchartsContainerForItemRightForSchool.resize()
      _that.myChartForEchartsContainerForItemRightForUser.resize()
      _that.myChartForEchartsContainerForAllNode.resize()
    })
  }

  updateCharts (who: any, option: any) {
    who.setOption(option, true)
  }

  async calcForCharts () {
    try {
      // 获取当前节点下面的所有学校：
      const arrAccordWithConditionChildForTree = getArrAccordWithConditionChildForTree(this.treeDataForSubOrganatizion, 'children', 'type', '1')
      this.schoolListForThisNode = arrAccordWithConditionChildForTree
      // 获取当前节点下的所有用户：
      const anyOneForListOnFlatteningForTree = getAnyOneForListOnFlatteningForTree(this.treeDataForSubOrganatizion, 'children')
      const { data: result } = await (this as any).$http.getSysUserList(
        {
          pageNo: 1,
          pageSize: 2000
        },
        {
          organizationId: anyOneForListOnFlatteningForTree.map(item => item.id)
        }
      )
      // if (result.code !== 200) return this.$message.error(result.msg)
      if (result.code === 200) {
        this.userListForThisNode = ((result.data && result.data.records) || [])
      }

      // 获取所有节点下面的所有学校：
      const arrAccordWithConditionChildForTreeOfAll = getArrAccordWithConditionChildForTree(this.treeDataForOrganatizion, 'children', 'type', '1')
      this.schoolListForAllNode = arrAccordWithConditionChildForTreeOfAll
      // 获取所有节点下的所有用户：
      const anyOneForListOnFlatteningForTreeOfAll = getAnyOneForListOnFlatteningForTree(this.treeDataForOrganatizion, 'children')
      const { data: resultOfAll } = await (this as any).$http.getSysUserList(
        {
          pageNo: 1,
          pageSize: 2000
        },
        {
          organizationId: anyOneForListOnFlatteningForTreeOfAll.map(item => item.id)
        }
      )
      // if (resultOfAll.code !== 200) return this.$message.error(result.msg)
      if (resultOfAll.code === 200) {
        this.userListForAllNode = ((resultOfAll.data && resultOfAll.data.records) || [])
      }

      // 处理组织图谱 start：
      let links = []
      const newAnyOneForListOnFlatteningForTree = JSON.parse(JSON.stringify(anyOneForListOnFlatteningForTree)).map(item => {
        item.id = String(item.id)
        item.pid = String(item.pid)
        const linkItem = {
          source: item.id,
          target: item.pid,
          lineStyle: {
            normal: {
              color: 'source',
              width: 3
            }
          }
        }
        links.push(linkItem)
        if (item.type === '0') {
          item['itemStyle'] = {
            color: '#FFA025',
            shadowColor: '#FFCA87',
            shadowBlur: 15
          }
          item['symbol'] = 'diamond'
          Object.assign(item, {
            symbolSize: 80,
            label: {
              position: 'right',
              rotate: 0,
              textStyle: {
                fontSize: 16,
                color: '#3A3838'
              }
            }
          })
        } else {
          item['itemStyle'] = {
            color: '#00DEDE',
            shadowColor: '#7CDCDC',
            shadowBlur: 15
          }
          Object.assign(item, {
            symbolSize: 37,
            label: {
              rotate: 0,
              textStyle: {
                fontSize: 12,
                color: '#CACACA'
              }
            }
          })
        }
        return item
      })
      this.optionForEchartsContainerForAllNode.series[0].data = newAnyOneForListOnFlatteningForTree
      this.optionForEchartsContainerForAllNode.series[0].links = links
      this.updateCharts(this.myChartForEchartsContainerForAllNode, this.optionForEchartsContainerForAllNode)
      // 处理组织图谱 end

      // dispose:
      this.optionForEchartsContainerForItemRightForSchool.series[0].data[0].value = this.schoolListForThisNode.length
      this.optionForEchartsContainerForItemRightForSchool.series[0].data[1].value = this.schoolListForAllNode.length
      this.optionForEchartsContainerForItemRightForUser.series[0].data[0].value = this.userListForThisNode.length
      this.optionForEchartsContainerForItemRightForUser.series[0].data[1].value = this.userListForAllNode.length
      this.updateCharts(this.myChartForEchartsContainerForItemRightForSchool, this.optionForEchartsContainerForItemRightForSchool)
      this.updateCharts(this.myChartForEchartsContainerForItemRightForUser, this.optionForEchartsContainerForItemRightForUser)
    } catch (err) {
      console.log(err)
    }
  }
}
